type Locale = 'tr' | 'en' | 'de';

const whatsappMessages = {
  tr: 'Merhaba, randevu almak istiyorum.',
  en: 'Hello, I would like to make an appointment.',
  de: 'Hallo, ich möchte einen Termin vereinbaren.'
};

export const redirectToWhatsApp = (locale: Locale = 'tr') => {
  const phoneNumber = '905438999586'; // +90 543 899 95 86 formatted for WhatsApp
  const message = whatsappMessages[locale] || whatsappMessages.tr;
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
}; 